import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/store/auth.store'
import { Loading } from '@/components/ui/loading'

export function PublicRoute() {
  const { user, loading } = useAuthStore()

  if (loading) {
    return <Loading />
  }

  return !user ? <Outlet /> : <Navigate to="/" replace />
} 